<template>
  <div
    v-if="onboardingStatus !== 'REJECTED'"
    class="application-review-container"
  >
    <div class="review-message">
      Your application is in review 👀.
    </div>
    <s-notification variant="primary" width="full">
      This takes anything from a few minutes up to a maximum of 2 business days.
    </s-notification>
  </div>

  <div
    v-else-if="failureReasonCategory === 'DECLINED'"
    class="declined-container"
  >
    <span class="declined-message">
      We can’t offer Chargebee Pay for your business. Our
      <c-link
        href="https://www.chargebee.com/docs/2.0/cb_payments_faq.html"
        target="_blank"
      >
        FAQ
      </c-link>
      lists the most common reasons why Chargebee Pay is declined for businesses.
    </span>
  </div>

  <div
    v-else-if="failureReasonCategory === 'NEEDS_ATTENTION'"
    class="needs-attention-container"
  >
    <div class="attention-message">
      Your application needs attention 🚨.
    </div>

    <div class="attention-notification">
      <s-notification variant="warning" size="large">
        Some of the information about your business could not be verified. Please review and resubmit.
      </s-notification>
    </div>

    <div class="review-button-wrapper">
      <c-button @click="navigateTo" variant="primary">
        <span class="review-button-text">Review Information</span>
      </c-button>
    </div>
  </div>
</template>


<script>
import { navigateTo } from "@/router";
import { RouteConstants } from "@/router/routeConstants";

export default {
  name: "ApplicationInReview",
  props: {
    onboardingStatus: {
      type: String,
      default: null,
    },
    failureReasonCategory: {
      type: String,
      default: null,
    },
  },
  methods: {
    navigateTo() {
      navigateTo(RouteConstants.INCREMENTAL_ONBOARDING_EDIT);
    }
  },

};
</script>

<style lang="scss">

.application-review-container {
  display: flex;
  flex-direction: column;
  font-weight: 400;

  .review-message {
    display: flex;
    margin-bottom: 8px;
  }
}

.declined-container {
  display: flex;
  width: 50%;

  .declined-message {
    font-size: 14px;
    font-weight: $fw_normal;
  }
}

.needs-attention-container {
  display: flex;
  flex-direction: column;

  .attention-message {
    display: flex;
    margin-bottom: 8px;
  }

  .attention-notification {
    margin-bottom: 8px;
  }

  .review-button-wrapper {
    margin-top: 4px;
    font-size: 14px;

    .c-button {
      display: flex;

      .c-button__label {
        padding: unset !important;
      }

      .review-button-text {
        display: flex;
      }

      .button-label {
        display: flex;
        align-items: center;
        font-weight: $fw_medium;
      }
    }
  }
}


</style>